/**
 * PLAN UI BUILDER - UI Simple sin Checkboxes
 */

class PlanUIBuilder {
    static buildTradingSession(value = []) {
        const sessions = ['Mañana', 'Tarde', 'Noche'];
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-blue-400 mb-3">SESIÓN DE TRADING</label>
                <div class="flex flex-wrap gap-2">
                    ${sessions.map(s => `
                        <button type="button" class="session-btn px-4 py-2 rounded border transition ${
                            value.includes(s.toLowerCase()) ? 'bg-blue-600 border-blue-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300 hover:bg-slate-600'
                        }" data-value="${s.toLowerCase()}" onclick="window.planManagerV2.toggleMultiSelect(this, 'trading_session')">
                            ${s}
                        </button>
                    `).join('')}
                </div>
            </div>
        `;
    }

    static buildPairCategory(value = []) {
        const categories = ['Forex', 'Crypto', 'Commodities', 'Indices', 'Stocks'];
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-emerald-400 mb-3">CATEGORÍA DE PARES</label>
                <div class="flex flex-wrap gap-2">
                    ${categories.map(c => `
                        <button type="button" class="category-btn px-4 py-2 rounded border transition text-sm ${
                            value.includes(c.toLowerCase()) ? 'bg-emerald-600 border-emerald-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300 hover:bg-slate-600'
                        }" data-value="${c.toLowerCase()}" onclick="window.planManagerV2.toggleMultiSelect(this, 'pair_category')">
                            ${c}
                        </button>
                    `).join('')}
                </div>
            </div>
        `;
    }

    static buildRiskLevel(value = '') {
        const levels = [
            { label: 'Bajo (1-2%)', value: 'Bajo' },
            { label: 'Medio (2-3%)', value: 'Medio' },
            { label: 'Alto (3-5%)', value: 'Alto' }
        ];
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-yellow-400 mb-3">NIVEL DE RIESGO</label>
                <select class="w-full bg-slate-700 border border-slate-600 rounded px-3 py-2 text-white" onchange="window.planManagerV2.setValue('risk_level', this.value)">
                    <option value="">Selecciona...</option>
                    ${levels.map(l => `<option value="${l.value}" ${value === l.value ? 'selected' : ''}>${l.label}</option>`).join('')}
                </select>
            </div>
        `;
    }

    static buildProfitGoal(value = '') {
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-emerald-400 mb-3">OBJETIVO DE GANANCIA ($)</label>
                <input type="number" min="0" step="0.01" value="${value}" placeholder="Ej: 100.00" 
                       class="w-full bg-slate-700 border border-slate-600 rounded px-3 py-2 text-white" 
                       onchange="window.planManagerV2.setValue('profit_goal', this.value)">
            </div>
        `;
    }

    static buildMaxDailyLoss(value = '') {
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-red-400 mb-3">PÉRDIDA MÁXIMA DIARIA ($)</label>
                <input type="number" min="0" step="0.01" value="${value}" placeholder="Ej: 50.00" 
                       class="w-full bg-slate-700 border border-slate-600 rounded px-3 py-2 text-white" 
                       onchange="window.planManagerV2.setValue('max_daily_loss', this.value)">
            </div>
        `;
    }

    static buildNewsReview(value = false) {
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-purple-400 mb-3">REVISIÓN DE NOTICIAS</label>
                <div class="flex gap-2">
                    <button type="button" class="flex-1 py-2 rounded border transition ${
                        value ? 'bg-emerald-600 border-emerald-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300'
                    }" onclick="window.planManagerV2.setToggle('news_review', true)">SÍ</button>
                    <button type="button" class="flex-1 py-2 rounded border transition ${
                        !value ? 'bg-slate-600 border-slate-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300'
                    }" onclick="window.planManagerV2.setToggle('news_review', false)">NO</button>
                </div>
            </div>
        `;
    }

    static buildSetupModel(value = false) {
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-cyan-400 mb-3">SETUP CUMPLE MODELO</label>
                <div class="flex gap-2">
                    <button type="button" class="flex-1 py-2 rounded border transition ${
                        value ? 'bg-emerald-600 border-emerald-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-300'
                    }" onclick="window.planManagerV2.setToggle('setup_matches_model', true)">SÍ</button>
                    <button type="button" class="flex-1 py-2 rounded border transition ${
                        !value ? 'bg-slate-600 border-slate-500 text-white' : 'bg-slate-700 border-slate-600 text-slate-300'
                    }" onclick="window.planManagerV2.setToggle('setup_matches_model', false)">NO</button>
                </div>
            </div>
        `;
    }

    static buildEmotionalState(value = '') {
        const states = ['Tranquilo', 'Ansioso', 'Confiado', 'Dudoso', 'Estresado'];
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-pink-400 mb-3">ESTADO EMOCIONAL</label>
                <select class="w-full bg-slate-700 border border-slate-600 rounded px-3 py-2 text-white" onchange="window.planManagerV2.setValue('emotional_state', this.value)">
                    <option value="">Selecciona...</option>
                    ${states.map(s => `<option value="${s}" ${value === s ? 'selected' : ''}>${s}</option>`).join('')}
                </select>
            </div>
        `;
    }

    static buildMaxTradesDay(value = 10) {
        return `
            <div class="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50">
                <label class="block text-sm font-bold text-indigo-400 mb-3">MAX TRADES POR DÍA: <span id="maxTradesValue">${value}</span></label>
                <input type="range" min="1" max="20" value="${value}" 
                       class="w-full" 
                       oninput="document.getElementById('maxTradesValue').textContent = this.value; window.planManagerV2.setValue('max_trades_day', this.value)">
            </div>
        `;
    }
}

if (typeof window !== 'undefined') {
    window.PlanUIBuilder = PlanUIBuilder;
}
